import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EducationAndQualificationList } from './-components/EducationAndQualificationList';
import { EducationAndQualificationSearchSchema } from './certification/-zod-schema';

const from = '/_staff/person/$id/_profile/education-and-qualification/';
const path = '/person/$id/education-and-qualification';

export const Route = createFileRoute(from)({
  component: RouteComponent,
  validateSearch: zodValidator(EducationAndQualificationSearchSchema),
});

function RouteComponent() {
  return <EducationAndQualificationList from={from} path={path} />;
}
